<template>
  <lm-icon-button
    class="LmStateButtonMini"
    :label="label"
    :icon="icon"
    :highlight="selected"
    :tooltip="tooltip"
    compacted
    svg
    @click="$emit('click', $event)"
  />
</template>

<script>
import LmIconButton from '@/components/ui/LmIconButton'
export default {
  name: 'LmStateButtonMini',
  components: {LmIconButton},
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'arrowDropUp'
    },
    label: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      default: null
    }
  }
}
</script>

<style>
/*
.LmStateButtonMini {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 11px;
  border: 1px solid #e5e5e5;
  color: #aaaaaa;
  background-color: white;
  cursor: pointer;
  font-size: 13px;
  .Icon {
    display: flex;
    justify-content: center;
    width: 12px;
    color: #aaaaaa;
  }
  &.is-selected {
    color: black;
    .Icon {
      color: black;
    }
  }
  .Label {
    margin-left: 6px;
  }
  &:hover .Icon {
    color: black;
  }
}
*/
.js-focus-visible .LmStateButtonMini:focus:not(.focus-visible) {
  outline: none;
}
</style>
